{
  "name": "@ns/invite-user",
  "version": "1.1.0",
  "description": "Invite a user to nodeStream.",
  "inputs": {
    "PAYMENT_APPROVER": {
      "type": "string",
      "optional": true
    }
  },
  "outcomes": {
    "invited": {}
  },
  "workflowMetadata": [
    "DIRECTOR_INVITATION_ID",
    "PAYMENT_APPROVER_INVITATION_ID"
  ]
}
